import { CommissionsProcessingToolPanel } from "../CommissionsProcessingToolPanel";
import { DataSource, Layout, Panel, Table } from "@mcleod/components";

export abstract class AutogenLayoutCommissionsProcessingHold extends Layout {
    layoutCommissionsProcessingToolPanel: CommissionsProcessingToolPanel;
    panelTaskFilters: Panel;
    sourceCommissionsProcessing: DataSource;
    tableCommissionsProcessing: Table;
}
